<script>
  import _base from '../../_default/components/_base.vue'
  import PMenu from './components/Menu.vue'
  import PregaoMenuStats from './components/Stats'
  import LoteLeilaoStats from './components/LoteLeilaoStats'
  import LoteInfo from './components/LoteInfo'
  import HistoricoLances from './components/HistoricoLances'
  import ILanceManual from './components/InputLanceManual'
  import IAlterarIncremento from './components/InputAlterarIncremento'
  import ChatComitenteResumido from './components/ChatResumidoComitente'
  import UKeyboard from './components/Keyboard'
  import {findIndex as _findIndex, merge as _merge} from 'lodash'
  import {Status as SocketStatus} from '../../../domain/leiloes/helpers/SocketStatus'
  import {number_format as numberFormat} from '../../../utils/helpers/phpjs'
  import ChangeStatus from './components/ChangeStatus.vue'
  import Service from '../../../domain/leiloes/services/pregao'

  export default{
    name: 'PregaoComitente',
    extends: _base,
    data () {
      return {
        leilao: {},
        pregao: null,
        lote: {
          numero: 0,
          imagem: null,
          descricao: '-',
          valorInicial: 0.00,
          valorIncremento: 0.00,
          valorMinimo: 0.00,
          valorMeta: 0.00,
          lancePrincipal: null,
          status: null,
          comitente: {
            pessoa: {}
          },
          pregao: null,
          lances: []
        },
        stats: {
          arrematantesOnline: 0,
          espectadoresOnline: 0,
          comitentesOnline: 0
        },
        isLoading: false,
        centerContentFolded: false
      }
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão')
      Service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.isLoading = false
          this.leilao = response.data.leilao
          this.lote = response.data.lote
          this.pregao = response.data.pregao
          if (this.pregao !== null) {
            window.setTimeout(() => {
              this.centerContentFolded = true
              this.$refs.keyboard.toggleKeyboard()
              this.$refs.painelLote.mountTimerCountdown()
            }, 500)
          }
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
          window.responseError(response)
          console.log(response)
        })
    },
    computed: {},
    mounted () {
      this.wsChannel = 'pregao/' + this.$route.params.id
      /* this.ws = WebSocket.connect(process.env.WS_URL, (session) => {
        this.ws.inscrever(this.wsChannel, this.processRemoteMessage)
        console.log('Conectado WS')
      }) */
      this._showMenu(false)
      this._showHeader(true)
      this._showFooter(false)
      this._menuFolded(false)
      this.$nextTick(() => {
        this.$root.$el.classList.add('full-height')
      })
    },
    destroyed () {
      this.$root.$el.classList.remove('full-height')
    },
    methods: {
      toggleKeyboard (v) {
        this.centerContentFolded = v
      },
      abrirPregao () {
        this.$loaderOverlay.open().message('Abrindo Pregão')
        Service.abrir(this.$route.params.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.isLoading = false
            this.leilao = response.data.leilao
            this.lote = response.data.lote
            this.pregao = response.data.pregao
            window.setTimeout(() => {
              this.centerContentFolded = true
              this.$refs.keyboard.toggleKeyboard()
            }, 100)
            this.ws.transmiteMensagem(this.wsChannel, SocketStatus.LEILAO_ABERTO)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            window.alert('Erro ao abrir o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            console.log(response)
          })
      },
      processRemoteMessage: function (uri, payload) {
        console.log('Received message', payload)
        if (typeof payload.code === 'undefined') {
          return
        }

        let message = payload
        let code = message.code
        let token = message.token

        let queue = this.ws._socketQueue.indexOf(token)
        if (queue > -1) {
          this.ws._socketQueue.splice(queue, 1)
          console.log('message from me. nothing to do')
          return // nothing to do
        }

        if (code === SocketStatus.LANCE.code) {
          // TODO: Esta implementação é insegura. Pode haver falha na sincronia do lancePrincipal via websocket. Resolver URGENTE antes do leilão 28/02/2018
          this.novoLance({id: message.lote, lancePrincipal: message.lance}, message.lance, true)
        }
      },
      mudarLote ({lote, pregao}) {
        this.lote = lote
        this.pregao = pregao
        this.reset()
        this.ws.transmiteMensagem(this.wsChannel, SocketStatus.LOTE_ALTERADO)
      },
      deletarLance (lance) {
        this.lote.lances.splice(_findIndex(this.lote.lances, lance), 1)
        this.ws.transmiteMensagem(this.wsChannel, _merge(SocketStatus.LOTE_ALTERADO, {
          bind: {
            lote: this.lote.id,
            lance: lance.id
          }
        }))
      },
      statusLote (lote) {
        delete this.lote.pregao
        _merge(this.lote, lote)
        this.$refs.painelLote.mountTimerCountdown()
        this.ws.transmiteMensagem(this.wsChannel, {
          code: SocketStatus.LOTE_STATUS_UPDATED.code,
          lote: this.lote.id,
          status: Number(lote.status),
          message: SocketStatus.LOTE_STATUS_UPDATED.message
        })
      },
      novoLance (lote, lance, noTransmitter) {
        console.log('Chamou', lote, lance, noTransmitter)
        noTransmitter = typeof noTransmitter !== 'undefined' ? noTransmitter : false
        // Verifica se o lote que recebeu o lance é o mesmo ativo na view
        if (lote.id !== this.lote.id) {
          return
        }
        _merge(this.lote, lote)
        this.lote.lances.unshift(lance)
        this.$refs.painelLote.mountTimerCountdown()
        this.$refs.painelLote.novoLance()
        if (!noTransmitter) {
          this.ws.transmiteMensagem(this.wsChannel, {
            code: SocketStatus.LANCE.code,
            message: SocketStatus.LANCE.message,
            bind: {lote: lote.id, lance: lance.id}
          })
        }
      },
      lanceManual (valor) {
        // Pré-validação (Se lance for igual ou menor que o último lance atual, não pode continuar
        this.$refs.keyboard.lanceManual(valor)
        this.$refs.keyboard.focusMe()
      },
      alterarIncremento (valor) {
        this.$confirm.open('Tem certeza que deseja alterar o incremento mínimo do lote para ' + numberFormat(valor, 2, ',', '.') + '?', 'Alterar', 'Cancelar', null, (v) => {
          if (v === false) {
            return
          }
          console.log('Trocando incremento mínimo para ' + valor + '...')
          this.$refs.changeStatus.open('Alterando incremento do lote')
          Service.alteraIncrementoMinimo(this.$route.params.id, this.lote.id, valor)
            .then((response) => {
              this.$refs.changeStatus.close()
              this.lote.valorIncremento = response.data.lote.valorIncremento
              this.ws.transmiteMensagem(this.wsChannel, _merge(SocketStatus.LOTE_ALTERADO, {bind: {lote: this.lote.id}}))
              this.$emit('incrementoLote', response.data.lote)
            })
            .catch((response) => {
              this.$refs.changeStatus.close()
              window.responseError(response)
              console.log(response)
            })
        })
        this.$refs.keyboard.focusMe()
      },
      reset () {
        this.$refs.painelLote.mountTimerCountdown()
      }
    },
    components: {
      UKeyboard,
      ChatComitenteResumido,
      IAlterarIncremento,
      ILanceManual,
      HistoricoLances,
      LoteInfo,
      LoteLeilaoStats,
      PregaoMenuStats,
      PMenu,
      ChangeStatus
    }
  }
</script>

<template>
  <div class="h-full">
    <change-status ref="changeStatus"></change-status>
    <div class="pregao" :class="{'show-keyboard': centerContentFolded, 'isLoading': isLoading}">

      <p-menu></p-menu>
      <pregao-menu-stats @abrirPregao="abrirPregao" :pregao="pregao" :leilao="leilao"
                         :stats="stats"></pregao-menu-stats>

      <lote-leilao-stats ref="painelLote" :lote="lote" :leilao="leilao"></lote-leilao-stats>

      <div class="content-center">
        <lote-info :lote="lote"></lote-info>
        <div class="manager-lances">
          <historico-lances :lote="lote"></historico-lances>
          <div class="lance-actions">
            <i-lance-manual @lanceManual="lanceManual"></i-lance-manual>
            <i-alterar-incremento @alterarIncremento="alterarIncremento"></i-alterar-incremento>
            <chat-comitente-resumido></chat-comitente-resumido>
          </div>
        </div>
      </div>

      <u-keyboard
        @mudarLote="mudarLote"
        @statusLote="statusLote"
        @deletarLance="deletarLance"
        @novoLance="novoLance"
        ref="keyboard"
        :startShow="centerContentFolded"
        @toggle="toggleKeyboard"></u-keyboard>

    </div>
  </div>
</template>

<style lang="scss" src="./assets/scss/default.scss"></style>



// WEBPACK FOOTER //
// Main.vue?2f655032